import { render, staticRenderFns } from "./ChannelView.vue?vue&type=template&id=1aaf025c&"
import script from "./ChannelView.vue?vue&type=script&lang=ts&"
export * from "./ChannelView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports